"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeInitialFileProperties = exports.serializeInitialFileProperties = void 0;
// Needs to be exported so clients can call it.
function serializeInitialFileProperties(state) {
    // @ts-ignore
    return window.btoa(JSON.stringify(state));
}
exports.serializeInitialFileProperties = serializeInitialFileProperties;
function deserializeInitialFileProperties(str) {
    // @ts-ignore
    return JSON.parse(window.atob(str));
}
exports.deserializeInitialFileProperties = deserializeInitialFileProperties;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJTZXJpYWxpemVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9NYXBtYWtlclNlcmlhbGl6ZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVNBLCtDQUErQztBQUMvQyxTQUFnQiw4QkFBOEIsQ0FDNUMsS0FBNEI7SUFFNUIsYUFBYTtJQUNiLE9BQU8sTUFBTSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7QUFDNUMsQ0FBQztBQUxELHdFQUtDO0FBRUQsU0FBZ0IsZ0NBQWdDLENBQzlDLEdBQVc7SUFFWCxhQUFhO0lBQ2IsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQXVCLENBQUM7QUFDNUQsQ0FBQztBQUxELDRFQUtDIn0=